/**
 * Auto-generated by generate-activity-defaults.ts – DO NOT EDIT MANUALLY.
 * Generated on: 2026-09-03T19:05:12.761Z
 *
 * Default activity selections per activity taxonomy (0 = default, others custom).
 * Ids are the custom-activity picker's ancestor-path ids; `levelId` is the
 * picker level (activity_k150, activity_k1500 or activity_k5000) the defaults live on.
 */

export type ActivityDefaultSelection = {
  id: string;
  name: string;
  levelId: 'activity_k150' | 'activity_k1500' | 'activity_k5000';
};

/** Activity taxonomy version these defaults were generated against. */
export const GENERATED_ACTIVITY_DEFAULTS_VERSION = '3.1.1';

// 0: default
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_DEFAULT: ActivityDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Business transformation and consulting',
      levelId: 'activity_k150',
    },
    {
      id: '37',
      name: 'Data management and processing',
      levelId: 'activity_k150',
    },
    {
      id: '80',
      name: 'Inventory management and service operations',
      levelId: 'activity_k150',
    },
    {
      id: '87',
      name: 'Logistics warehousing and supply chain',
      levelId: 'activity_k150',
    },
    {
      id: '135',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 1: rics_k50_1
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_1: ActivityDefaultSelection[] =
  [
    {
      id: '24',
      name: 'Data operations and documentation management',
      levelId: 'activity_k150',
    },
    {
      id: '66',
      name: 'Inventory and warehouse operations management',
      levelId: 'activity_k150',
    },
    {
      id: '105',
      name: 'Reception and administrative support',
      levelId: 'activity_k150',
    },
    {
      id: '119',
      name: 'Strategic business transformation',
      levelId: 'activity_k150',
    },
    {
      id: '134',
      name: 'Talent development and management',
      levelId: 'activity_k150',
    },
  ];

// 2: rics_k50_2
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_2: ActivityDefaultSelection[] =
  [
    {
      id: '53',
      name: 'Frontline customer service',
      levelId: 'activity_k150',
    },
    {
      id: '89',
      name: 'Order fulfillment and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '90',
      name: 'Organizational change management',
      levelId: 'activity_k150',
    },
    {
      id: '114',
      name: 'Research data and analytics',
      levelId: 'activity_k150',
    },
    {
      id: '134',
      name: 'Strategic talent acquisition',
      levelId: 'activity_k150',
    },
  ];

// 3: rics_k50_3
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_3: ActivityDefaultSelection[] =
  [
    {
      id: '20',
      name: 'Data analytics and reporting',
      levelId: 'activity_k150',
    },
    {
      id: '43',
      name: 'Front Desk and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '52',
      name: 'Inventory management and logistics operations',
      levelId: 'activity_k150',
    },
    {
      id: '121',
      name: 'Strategic HR consulting and development',
      levelId: 'activity_k150',
    },
    {
      id: '137',
      name: 'Technology implementation and solutions',
      levelId: 'activity_k150',
    },
  ];

// 4: rics_k50_4
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_4: ActivityDefaultSelection[] =
  [
    {
      id: '17',
      name: 'Consulting services and client engagement',
      levelId: 'activity_k150',
    },
    {
      id: '72',
      name: 'Inventory control logistics management',
      levelId: 'activity_k150',
    },
    {
      id: '106',
      name: 'Recruitment and talent acquisition',
      levelId: 'activity_k150',
    },
    {
      id: '116',
      name: 'Software development and data science',
      levelId: 'activity_k150',
    },
    {
      id: '131',
      name: 'Supervision and facility coordination',
      levelId: 'activity_k150',
    },
  ];

// 5: rics_k50_5
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_5: ActivityDefaultSelection[] =
  [
    {
      id: '12',
      name: 'Client implementation and consulting delivery',
      levelId: 'activity_k150',
    },
    {
      id: '28',
      name: 'Data analysis and business intelligence',
      levelId: 'activity_k150',
    },
    {
      id: '66',
      name: 'Inventory management and procurement',
      levelId: 'activity_k150',
    },
    {
      id: '106',
      name: 'Reception and guest services',
      levelId: 'activity_k150',
    },
    {
      id: '138',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 6: rics_k50_6
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_6: ActivityDefaultSelection[] =
  [
    {
      id: '26',
      name: 'Data analysis and visualization',
      levelId: 'activity_k150',
    },
    {
      id: '33',
      name: 'Employee development and engagement strategy',
      levelId: 'activity_k150',
    },
    {
      id: '62',
      name: 'Leadership development and support services',
      levelId: 'activity_k150',
    },
    {
      id: '77',
      name: 'Order fulfillment logistics operations',
      levelId: 'activity_k150',
    },
    {
      id: '120',
      name: 'Strategic planning and business development',
      levelId: 'activity_k150',
    },
  ];

// 7: rics_k50_7
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_7: ActivityDefaultSelection[] =
  [
    {
      id: '12',
      name: 'Client services and consulting delivery',
      levelId: 'activity_k150',
    },
    {
      id: '59',
      name: 'Front Office customer service operations',
      levelId: 'activity_k150',
    },
    {
      id: '128',
      name: 'Statistical analysis and data reporting',
      levelId: 'activity_k150',
    },
    {
      id: '137',
      name: 'Supply chain planning and operations',
      levelId: 'activity_k150',
    },
    {
      id: '139',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 8: rics_k50_8
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_8: ActivityDefaultSelection[] =
  [
    {
      id: '41',
      name: 'Data management and analytics',
      levelId: 'activity_k150',
    },
    {
      id: '106',
      name: 'Retail customer service and checkout',
      levelId: 'activity_k150',
    },
    {
      id: '121',
      name: 'Shipping and logistics coordination',
      levelId: 'activity_k150',
    },
    {
      id: '127',
      name: 'Strategic account management and transformation',
      levelId: 'activity_k150',
    },
    {
      id: '131',
      name: 'Strategic talent acquisition and client relations',
      levelId: 'activity_k150',
    },
  ];

// 9: rics_k50_9
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_9: ActivityDefaultSelection[] =
  [
    {
      id: '28',
      name: 'Customer service and cash handling',
      levelId: 'activity_k150',
    },
    {
      id: '45',
      name: 'Enterprise technology implementation',
      levelId: 'activity_k150',
    },
    {
      id: '66',
      name: 'HR operations and employee Experience',
      levelId: 'activity_k150',
    },
    {
      id: '83',
      name: 'Logistics and operations management',
      levelId: 'activity_k150',
    },
    {
      id: '107',
      name: 'Program management and stakeholder relations',
      levelId: 'activity_k150',
    },
  ];

// 10: rics_k50_10
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_10: ActivityDefaultSelection[] =
  [
    {
      id: '27',
      name: 'Customer service and team leadership',
      levelId: 'activity_k150',
    },
    {
      id: '33',
      name: 'Data processing and visualization',
      levelId: 'activity_k150',
    },
    {
      id: '70',
      name: 'Internal recruitment coordination and operations',
      levelId: 'activity_k150',
    },
    {
      id: '110',
      name: 'Sales and inventory operations',
      levelId: 'activity_k150',
    },
    {
      id: '128',
      name: 'Strategic leadership and transformation management',
      levelId: 'activity_k150',
    },
  ];

// 11: rics_k50_11
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_11: ActivityDefaultSelection[] =
  [
    {
      id: '1',
      name: 'AI and machine learning development',
      levelId: 'activity_k150',
    },
    {
      id: '23',
      name: 'Customer service and transaction processing',
      levelId: 'activity_k150',
    },
    {
      id: '126',
      name: 'Strategic planning and solution development',
      levelId: 'activity_k150',
    },
    {
      id: '131',
      name: 'Talent acquisition and recruitment operations',
      levelId: 'activity_k150',
    },
    {
      id: '148',
      name: 'Warehouse inventory control and oversight',
      levelId: 'activity_k150',
    },
  ];

// 12: rics_k50_12
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_12: ActivityDefaultSelection[] =
  [
    {
      id: '20',
      name: 'Commercial strategy and business development',
      levelId: 'activity_k150',
    },
    {
      id: '37',
      name: 'Data analysis and research',
      levelId: 'activity_k150',
    },
    {
      id: '125',
      name: 'Strategic HR management and talent acquisition',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Supply chain operations',
      levelId: 'activity_k150',
    },
    {
      id: '145',
      name: 'Visitor services and customer assistance',
      levelId: 'activity_k150',
    },
  ];

// 13: rics_k50_13
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_13: ActivityDefaultSelection[] =
  [
    {
      id: '8',
      name: 'Business analysis and solution implementation',
      levelId: 'activity_k150',
    },
    {
      id: '28',
      name: 'Data engineering and database management',
      levelId: 'activity_k150',
    },
    {
      id: '51',
      name: 'Front Desk and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '125',
      name: 'Strategic talent acquisition',
      levelId: 'activity_k150',
    },
    {
      id: '147',
      name: 'Warehouse inventory management operations',
      levelId: 'activity_k150',
    },
  ];

// 14: rics_k50_14
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_14: ActivityDefaultSelection[] =
  [
    {
      id: '6',
      name: 'Business analysis and process improvement',
      levelId: 'activity_k150',
    },
    {
      id: '27',
      name: 'Data processing and analysis',
      levelId: 'activity_k150',
    },
    {
      id: '106',
      name: 'Retail cash handling and POS operations',
      levelId: 'activity_k150',
    },
    {
      id: '108',
      name: 'Retail store operations and inventory control',
      levelId: 'activity_k150',
    },
    {
      id: '125',
      name: 'Strategic and operational recruitment management',
      levelId: 'activity_k150',
    },
  ];

// 15: rics_k50_15
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_15: ActivityDefaultSelection[] =
  [
    {
      id: '15',
      name: 'Business development and sales',
      levelId: 'activity_k150',
    },
    {
      id: '36',
      name: 'Data pipeline engineering',
      levelId: 'activity_k150',
    },
    {
      id: '69',
      name: 'Guest services and event coordination',
      levelId: 'activity_k150',
    },
    {
      id: '79',
      name: 'Inventory management and logistics operations',
      levelId: 'activity_k150',
    },
    {
      id: '137',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 16: rics_k50_16
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_16: ActivityDefaultSelection[] =
  [
    {
      id: '4',
      name: 'Analyzing data and creating reports',
      levelId: 'activity_k150',
    },
    {
      id: '27',
      name: 'ERP implementation and process excellence',
      levelId: 'activity_k150',
    },
    {
      id: '55',
      name: 'Inventory management and stock control',
      levelId: 'activity_k150',
    },
    {
      id: '112',
      name: 'Store operations and inventory management',
      levelId: 'activity_k150',
    },
    {
      id: '113',
      name: 'Strategic HR and employee Experience',
      levelId: 'activity_k150',
    },
  ];

// 17: rics_k50_17
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_17: ActivityDefaultSelection[] =
  [
    {
      id: '66',
      name: 'Inventory and logistics management',
      levelId: 'activity_k150',
    },
    {
      id: '109',
      name: 'Retail customer service excellence',
      levelId: 'activity_k150',
    },
    {
      id: '129',
      name: 'Strategic research and business analysis',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
    {
      id: '142',
      name: 'Technology implementation and transformation consulting',
      levelId: 'activity_k150',
    },
  ];

// 18: rics_k50_18
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_18: ActivityDefaultSelection[] =
  [
    {
      id: '24',
      name: 'Data analytics and reporting',
      levelId: 'activity_k150',
    },
    {
      id: '62',
      name: 'HR operations and strategic support',
      levelId: 'activity_k150',
    },
    {
      id: '71',
      name: 'Inventory and materials management',
      levelId: 'activity_k150',
    },
    {
      id: '112',
      name: 'Retail customer service and stock',
      levelId: 'activity_k150',
    },
    {
      id: '128',
      name: 'Strategic transformation and change leadership',
      levelId: 'activity_k150',
    },
  ];

// 19: rics_k50_19
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_19: ActivityDefaultSelection[] =
  [
    {
      id: '11',
      name: 'Business transformation and change management',
      levelId: 'activity_k150',
    },
    {
      id: '31',
      name: 'Data analysis and insight generation',
      levelId: 'activity_k150',
    },
    {
      id: '89',
      name: 'Order fulfillment and inventory management',
      levelId: 'activity_k150',
    },
    {
      id: '110',
      name: 'Retail sales and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '133',
      name: 'Talent acquisition and recruitment operations',
      levelId: 'activity_k150',
    },
  ];

// 20: rics_k50_20
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_20: ActivityDefaultSelection[] =
  [
    {
      id: '28',
      name: 'Data analysis and research',
      levelId: 'activity_k150',
    },
    {
      id: '58',
      name: 'Guest welcome and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '112',
      name: 'Sales and inventory operations',
      levelId: 'activity_k150',
    },
    {
      id: '128',
      name: 'Strategic initiative execution and implementation',
      levelId: 'activity_k150',
    },
    {
      id: '130',
      name: 'Strategic talent acquisition leadership',
      levelId: 'activity_k150',
    },
  ];

// 21: rics_k50_21
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_21: ActivityDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Business analysis process improvement',
      levelId: 'activity_k150',
    },
    {
      id: '40',
      name: 'Data analytics and financial analysis',
      levelId: 'activity_k150',
    },
    {
      id: '60',
      name: 'Frontline customer service operations',
      levelId: 'activity_k150',
    },
    {
      id: '116',
      name: 'Sales operations and client management',
      levelId: 'activity_k150',
    },
    {
      id: '138',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 22: rics_k50_22
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_22: ActivityDefaultSelection[] =
  [
    {
      id: '2',
      name: 'Administrative and Language services',
      levelId: 'activity_k150',
    },
    {
      id: '48',
      name: 'Enterprise strategic initiative execution',
      levelId: 'activity_k150',
    },
    {
      id: '66',
      name: 'Front Desk and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '85',
      name: 'Inventory and warehouse operations',
      levelId: 'activity_k150',
    },
    {
      id: '121',
      name: 'Recruitment and talent acquisition',
      levelId: 'activity_k150',
    },
  ];

// 23: rics_k50_23
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_23: ActivityDefaultSelection[] =
  [
    {
      id: '8',
      name: 'Business transformation and implementation',
      levelId: 'activity_k150',
    },
    {
      id: '27',
      name: 'Data analysis and statistical modeling',
      levelId: 'activity_k150',
    },
    {
      id: '87',
      name: 'Point of sale and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '98',
      name: 'Recruitment and talent acquisition',
      levelId: 'activity_k150',
    },
    {
      id: '104',
      name: 'Retail operations and inventory management',
      levelId: 'activity_k150',
    },
  ];

// 24: rics_k50_24
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_24: ActivityDefaultSelection[] =
  [
    {
      id: '11',
      name: 'Business data analytics and reporting',
      levelId: 'activity_k150',
    },
    {
      id: '77',
      name: 'Inventory control accuracy and auditing',
      levelId: 'activity_k150',
    },
    {
      id: '94',
      name: 'Operational support and assistance',
      levelId: 'activity_k150',
    },
    {
      id: '111',
      name: 'Recruitment and talent acquisition',
      levelId: 'activity_k150',
    },
    {
      id: '122',
      name: 'SAP ERP implementation and solution delivery',
      levelId: 'activity_k150',
    },
  ];

// 25: rics_k50_25
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_25: ActivityDefaultSelection[] =
  [
    {
      id: '33',
      name: 'Data operations and analytics',
      levelId: 'activity_k150',
    },
    {
      id: '57',
      name: 'HR operations and Systems',
      levelId: 'activity_k150',
    },
    {
      id: '72',
      name: 'Inventory and supply chain management',
      levelId: 'activity_k150',
    },
    {
      id: '100',
      name: 'Project delivery and change management',
      levelId: 'activity_k150',
    },
    {
      id: '110',
      name: 'Retail customer service cashier',
      levelId: 'activity_k150',
    },
  ];

// 26: rics_k50_26
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_26: ActivityDefaultSelection[] =
  [
    {
      id: '32',
      name: 'Data analytics and business intelligence',
      levelId: 'activity_k150',
    },
    {
      id: '66',
      name: 'Front desk reception and visitor services',
      levelId: 'activity_k150',
    },
    {
      id: '69',
      name: 'HR operations and payroll management',
      levelId: 'activity_k150',
    },
    {
      id: '79',
      name: 'Inventory control and management',
      levelId: 'activity_k150',
    },
    {
      id: '129',
      name: 'Strategic consulting and program management',
      levelId: 'activity_k150',
    },
  ];

// 27: rics_k50_27
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_27: ActivityDefaultSelection[] =
  [
    {
      id: '17',
      name: 'Client consulting and advisory services',
      levelId: 'activity_k150',
    },
    {
      id: '37',
      name: 'Data management and analysis',
      levelId: 'activity_k150',
    },
    {
      id: '49',
      name: 'Event guest services operations',
      levelId: 'activity_k150',
    },
    {
      id: '118',
      name: 'Sales and inventory operations',
      levelId: 'activity_k150',
    },
    {
      id: '136',
      name: 'Talent management and employee Experience',
      levelId: 'activity_k150',
    },
  ];

// 28: rics_k50_28
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_28: ActivityDefaultSelection[] =
  [
    {
      id: '31',
      name: 'Data analysis and business reporting',
      levelId: 'activity_k150',
    },
    {
      id: '65',
      name: 'Front desk and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '130',
      name: 'Strategic initiative execution and transformation',
      levelId: 'activity_k150',
    },
    {
      id: '141',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
    {
      id: '149',
      name: 'Warehouse inventory control',
      levelId: 'activity_k150',
    },
  ];

// 29: rics_k50_29
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_29: ActivityDefaultSelection[] =
  [
    {
      id: '33',
      name: 'Data quality assurance and reporting',
      levelId: 'activity_k150',
    },
    {
      id: '43',
      name: 'Enterprise consulting services',
      levelId: 'activity_k150',
    },
    {
      id: '50',
      name: 'Front Desk operations and administrative support',
      levelId: 'activity_k150',
    },
    {
      id: '68',
      name: 'Inventory management and logistics',
      levelId: 'activity_k150',
    },
    {
      id: '128',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 30: rics_k50_30
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_30: ActivityDefaultSelection[] =
  [
    {
      id: '10',
      name: 'Branch operations and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '15',
      name: 'Business solution delivery and implementation',
      levelId: 'activity_k150',
    },
    {
      id: '37',
      name: 'Data analytics and engineering simulation',
      levelId: 'activity_k150',
    },
    {
      id: '72',
      name: 'Logistics coordination and management',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 31: rics_k50_31
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_31: ActivityDefaultSelection[] =
  [
    {
      id: '14',
      name: 'Consulting and strategic analysis',
      levelId: 'activity_k150',
    },
    {
      id: '21',
      name: 'Customer service and reception duties',
      levelId: 'activity_k150',
    },
    {
      id: '81',
      name: 'Order fulfillment and procurement operations',
      levelId: 'activity_k150',
    },
    {
      id: '127',
      name: 'Talent acquisition sourcing operations',
      levelId: 'activity_k150',
    },
    {
      id: '141',
      name: 'Technology consulting and solution architecture',
      levelId: 'activity_k150',
    },
  ];

// 32: rics_k50_32
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_32: ActivityDefaultSelection[] =
  [
    {
      id: '11',
      name: 'Client consulting and business analysis',
      levelId: 'activity_k150',
    },
    {
      id: '31',
      name: 'Customer service and guest relations',
      levelId: 'activity_k150',
    },
    {
      id: '39',
      name: 'Data preparation and analysis operations',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
    {
      id: '148',
      name: 'Vendor management and procurement operations',
      levelId: 'activity_k150',
    },
  ];

// 33: rics_k50_33
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_33: ActivityDefaultSelection[] =
  [
    {
      id: '33',
      name: 'Data analysis and document processing',
      levelId: 'activity_k150',
    },
    {
      id: '109',
      name: 'New business development and sales',
      levelId: 'activity_k150',
    },
    {
      id: '111',
      name: 'Office and administrative support',
      levelId: 'activity_k150',
    },
    {
      id: '122',
      name: 'Reception and front Desk operations',
      levelId: 'activity_k150',
    },
    {
      id: '124',
      name: 'Recruitment coordination and talent acquisition',
      levelId: 'activity_k150',
    },
  ];

// 34: rics_k50_34
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_34: ActivityDefaultSelection[] =
  [
    {
      id: '22',
      name: 'Customer service and cash handling',
      levelId: 'activity_k150',
    },
    {
      id: '29',
      name: 'Data analysis and statistical modeling',
      levelId: 'activity_k150',
    },
    {
      id: '64',
      name: 'Inventory management and control',
      levelId: 'activity_k150',
    },
    {
      id: '74',
      name: 'New business and partnership development',
      levelId: 'activity_k150',
    },
    {
      id: '96',
      name: 'Recruitment and talent acquisition',
      levelId: 'activity_k150',
    },
  ];

// 35: rics_k50_35
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_35: ActivityDefaultSelection[] =
  [
    {
      id: '60',
      name: 'Guest services and event support',
      levelId: 'activity_k150',
    },
    {
      id: '80',
      name: 'Managing strategic client relationships',
      levelId: 'activity_k150',
    },
    {
      id: '120',
      name: 'Stock management operations',
      levelId: 'activity_k150',
    },
    {
      id: '131',
      name: 'Survey design and quantitative research',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 36: rics_k50_36
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_36: ActivityDefaultSelection[] =
  [
    {
      id: '10',
      name: 'Competitive intelligence and market analysis',
      levelId: 'activity_k150',
    },
    {
      id: '36',
      name: 'Employee development and support services',
      levelId: 'activity_k150',
    },
    {
      id: '41',
      name: 'Enterprise transformation and change management',
      levelId: 'activity_k150',
    },
    {
      id: '67',
      name: 'Inventory management and material operations',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Strategic talent management and workforce development',
      levelId: 'activity_k150',
    },
  ];

// 37: rics_k50_37
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_37: ActivityDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Change management and implementation support',
      levelId: 'activity_k150',
    },
    {
      id: '33',
      name: 'Customer order processing and support',
      levelId: 'activity_k150',
    },
    {
      id: '58',
      name: 'Front Desk and guest reception',
      levelId: 'activity_k150',
    },
    {
      id: '110',
      name: 'Research and analysis',
      levelId: 'activity_k150',
    },
    {
      id: '133',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 38: rics_k50_38
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_38: ActivityDefaultSelection[] =
  [
    {
      id: '13',
      name: 'Business transformation and consulting',
      levelId: 'activity_k150',
    },
    {
      id: '37',
      name: 'Data management and processing',
      levelId: 'activity_k150',
    },
    {
      id: '80',
      name: 'Inventory management and service operations',
      levelId: 'activity_k150',
    },
    {
      id: '87',
      name: 'Logistics warehousing and supply chain',
      levelId: 'activity_k150',
    },
    {
      id: '135',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 39: rics_k50_39
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_39: ActivityDefaultSelection[] =
  [
    {
      id: '5',
      name: 'Advanced analytics modeling and optimization',
      levelId: 'activity_k150',
    },
    {
      id: '15',
      name: 'Client relationship management and consulting',
      levelId: 'activity_k150',
    },
    {
      id: '61',
      name: 'Inventory management and control',
      levelId: 'activity_k150',
    },
    {
      id: '67',
      name: 'Learning and development strategy',
      levelId: 'activity_k150',
    },
    {
      id: '80',
      name: 'Office administration and reception support',
      levelId: 'activity_k150',
    },
  ];

// 40: rics_k50_40
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_40: ActivityDefaultSelection[] =
  [
    {
      id: '48',
      name: 'HR strategic planning and analytics',
      levelId: 'activity_k150',
    },
    {
      id: '109',
      name: 'Reporting and analytics',
      levelId: 'activity_k150',
    },
    {
      id: '112',
      name: 'Retail customer service operations',
      levelId: 'activity_k150',
    },
    {
      id: '114',
      name: 'Retail store inventory operations',
      levelId: 'activity_k150',
    },
    {
      id: '127',
      name: 'Strategic business analysis and transformation',
      levelId: 'activity_k150',
    },
  ];

// 41: rics_k50_41
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_41: ActivityDefaultSelection[] =
  [
    {
      id: '18',
      name: 'Client consulting and implementation services',
      levelId: 'activity_k150',
    },
    {
      id: '42',
      name: 'Data analysis and reporting',
      levelId: 'activity_k150',
    },
    {
      id: '72',
      name: 'Internal operations management and inventory control',
      levelId: 'activity_k150',
    },
    {
      id: '104',
      name: 'Retail customer service and sales support',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Talent development and organizational development',
      levelId: 'activity_k150',
    },
  ];

// 42: rics_k50_42
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_42: ActivityDefaultSelection[] =
  [
    {
      id: '26',
      name: 'Customer and guest relations',
      levelId: 'activity_k150',
    },
    {
      id: '30',
      name: 'Data management and database operations',
      levelId: 'activity_k150',
    },
    {
      id: '72',
      name: 'Inventory control and warehouse operations',
      levelId: 'activity_k150',
    },
    {
      id: '114',
      name: 'Recruitment operations and talent acquisition',
      levelId: 'activity_k150',
    },
    {
      id: '120',
      name: 'Requirements and solution delivery',
      levelId: 'activity_k150',
    },
  ];

// 43: rics_k50_43
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_43: ActivityDefaultSelection[] =
  [
    {
      id: '11',
      name: 'Cashier and frontline customer service',
      levelId: 'activity_k150',
    },
    {
      id: '32',
      name: 'Data management and operations',
      levelId: 'activity_k150',
    },
    {
      id: '63',
      name: 'HR operations and strategic support',
      levelId: 'activity_k150',
    },
    {
      id: '80',
      name: 'Logistics and inventory operations',
      levelId: 'activity_k150',
    },
    {
      id: '94',
      name: 'Organizational change management and consulting',
      levelId: 'activity_k150',
    },
  ];

// 44: rics_k50_44
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_44: ActivityDefaultSelection[] =
  [
    {
      id: '23',
      name: 'Data management and analysis',
      levelId: 'activity_k150',
    },
    {
      id: '49',
      name: 'Guest services and reservations',
      levelId: 'activity_k150',
    },
    {
      id: '81',
      name: 'Operational performance and consulting',
      levelId: 'activity_k150',
    },
    {
      id: '90',
      name: 'Procurement and supplier management',
      levelId: 'activity_k150',
    },
    {
      id: '134',
      name: 'Talent acquisition and recruiting',
      levelId: 'activity_k150',
    },
  ];

// 45: rics_k50_45
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_45: ActivityDefaultSelection[] =
  [
    {
      id: '16',
      name: 'Client consulting and business transformation',
      levelId: 'activity_k150',
    },
    {
      id: '37',
      name: 'Data science and statistical modeling',
      levelId: 'activity_k150',
    },
    {
      id: '116',
      name: 'Retail customer service Desk',
      levelId: 'activity_k150',
    },
    {
      id: '119',
      name: 'Retail store operations and merchandising',
      levelId: 'activity_k150',
    },
    {
      id: '135',
      name: 'Strategic talent acquisition and development',
      levelId: 'activity_k150',
    },
  ];

// 46: rics_k50_46
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_46: ActivityDefaultSelection[] =
  [
    {
      id: '91',
      name: 'Operations and facility support',
      levelId: 'activity_k150',
    },
    {
      id: '106',
      name: 'Program implementation and business transformation',
      levelId: 'activity_k150',
    },
    {
      id: '128',
      name: 'Statistical analysis and reporting',
      levelId: 'activity_k150',
    },
    {
      id: '129',
      name: 'Strategic HR leadership and talent management',
      levelId: 'activity_k150',
    },
    {
      id: '135',
      name: 'Supply chain and logistics support',
      levelId: 'activity_k150',
    },
  ];

// 47: rics_k50_47
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_47: ActivityDefaultSelection[] =
  [
    {
      id: '22',
      name: 'Customer service and guest relations',
      levelId: 'activity_k150',
    },
    {
      id: '77',
      name: 'Operational support and data services',
      levelId: 'activity_k150',
    },
    {
      id: '82',
      name: 'Organizational change and strategic planning',
      levelId: 'activity_k150',
    },
    {
      id: '91',
      name: 'Procurement, inventory management, vendor coordination',
      levelId: 'activity_k150',
    },
    {
      id: '138',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 48: rics_k50_48
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_48: ActivityDefaultSelection[] =
  [
    {
      id: '23',
      name: 'Customer greeting and orientation',
      levelId: 'activity_k150',
    },
    {
      id: '27',
      name: 'Data science analytics',
      levelId: 'activity_k150',
    },
    {
      id: '116',
      name: 'Strategic HR and payroll operations',
      levelId: 'activity_k150',
    },
    {
      id: '123',
      name: 'Strategic planning and business transformation',
      levelId: 'activity_k150',
    },
    {
      id: '148',
      name: 'Warehouse and inventory management',
      levelId: 'activity_k150',
    },
  ];

// 49: rics_k50_49
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_49: ActivityDefaultSelection[] =
  [
    {
      id: '36',
      name: 'Data analysis and business insights',
      levelId: 'activity_k150',
    },
    {
      id: '64',
      name: 'Guest services and customer Experience',
      levelId: 'activity_k150',
    },
    {
      id: '73',
      name: 'Inventory control and order management',
      levelId: 'activity_k150',
    },
    {
      id: '125',
      name: 'Strategic initiative and program management',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 50: rics_k50_50
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_50: ActivityDefaultSelection[] =
  [
    {
      id: '21',
      name: 'Customer service operations',
      levelId: 'activity_k150',
    },
    {
      id: '23',
      name: 'Data analysis research and reporting',
      levelId: 'activity_k150',
    },
    {
      id: '56',
      name: 'Inventory management and procurement',
      levelId: 'activity_k150',
    },
    {
      id: '88',
      name: 'Organizational transformation and change',
      levelId: 'activity_k150',
    },
    {
      id: '138',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];

// 51: rics_k10_1
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_51: ActivityDefaultSelection[] =
  [
    {
      id: '5',
      name: 'Business transformation and program management',
      levelId: 'activity_k150',
    },
    {
      id: '18',
      name: 'Customer service and entrance security',
      levelId: 'activity_k150',
    },
    {
      id: '67',
      name: 'Inventory management coordination',
      levelId: 'activity_k150',
    },
    {
      id: '110',
      name: 'Research analysis and training development',
      levelId: 'activity_k150',
    },
    {
      id: '137',
      name: 'Talent acquisition training and development',
      levelId: 'activity_k150',
    },
  ];

// 52: rics_k10_2
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_52: ActivityDefaultSelection[] =
  [
    {
      id: '7',
      name: 'Business analysis reporting and process improvement',
      levelId: 'activity_k150',
    },
    {
      id: '27',
      name: 'Data analysis and visualization',
      levelId: 'activity_k150',
    },
    {
      id: '70',
      name: 'Inventory management and control',
      levelId: 'activity_k150',
    },
    {
      id: '111',
      name: 'Retail cashiering and transactions',
      levelId: 'activity_k150',
    },
    {
      id: '131',
      name: 'Strategic talent acquisition planning and management',
      levelId: 'activity_k150',
    },
  ];

// 53: rics_k10_3
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_53: ActivityDefaultSelection[] =
  [
    {
      id: '26',
      name: 'Data science and analytics',
      levelId: 'activity_k150',
    },
    {
      id: '70',
      name: 'Logistics management and inventory control',
      levelId: 'activity_k150',
    },
    {
      id: '109',
      name: 'Reception and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '110',
      name: 'Recruitment and talent acquisition',
      levelId: 'activity_k150',
    },
    {
      id: '136',
      name: 'Strategic financial planning and analysis',
      levelId: 'activity_k150',
    },
  ];

// 54: rics_k10_4
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_54: ActivityDefaultSelection[] =
  [
    {
      id: '32',
      name: 'Customer service and cashiering',
      levelId: 'activity_k150',
    },
    {
      id: '39',
      name: 'Data quality management and reporting',
      levelId: 'activity_k150',
    },
    {
      id: '100',
      name: 'Organizational transformation and change management',
      levelId: 'activity_k150',
    },
    {
      id: '103',
      name: 'Procurement, supply chain, and logistics management',
      levelId: 'activity_k150',
    },
    {
      id: '140',
      name: 'Talent acquisition',
      levelId: 'activity_k150',
    },
  ];

// 55: rics_k10_5
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_55: ActivityDefaultSelection[] =
  [
    {
      id: '34',
      name: 'Data analytics reporting',
      levelId: 'activity_k150',
    },
    {
      id: '59',
      name: 'Front desk and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '72',
      name: 'Inventory and logistics management',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Strategic talent acquisition leadership',
      levelId: 'activity_k150',
    },
    {
      id: '145',
      name: 'Technology strategy alignment',
      levelId: 'activity_k150',
    },
  ];

// 56: rics_k10_6
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_56: ActivityDefaultSelection[] =
  [
    {
      id: '6',
      name: 'Business consulting and implementation services',
      levelId: 'activity_k150',
    },
    {
      id: '23',
      name: 'Customer service and support',
      levelId: 'activity_k150',
    },
    {
      id: '66',
      name: 'Investment analysis and portfolio management',
      levelId: 'activity_k150',
    },
    {
      id: '129',
      name: 'Talent acquisition and recruitment management',
      levelId: 'activity_k150',
    },
    {
      id: '142',
      name: 'Transportation logistics and order management',
      levelId: 'activity_k150',
    },
  ];

// 57: rics_k10_7
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_57: ActivityDefaultSelection[] =
  [
    {
      id: '33',
      name: 'Data analysis and document processing',
      levelId: 'activity_k150',
    },
    {
      id: '109',
      name: 'New business development and sales',
      levelId: 'activity_k150',
    },
    {
      id: '111',
      name: 'Office and administrative support',
      levelId: 'activity_k150',
    },
    {
      id: '122',
      name: 'Reception and front Desk operations',
      levelId: 'activity_k150',
    },
    {
      id: '124',
      name: 'Recruitment coordination and talent acquisition',
      levelId: 'activity_k150',
    },
  ];

// 58: rics_k10_8
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_58: ActivityDefaultSelection[] =
  [
    {
      id: '33',
      name: 'Data analysis and management',
      levelId: 'activity_k150',
    },
    {
      id: '54',
      name: 'Fulfillment center operations',
      levelId: 'activity_k150',
    },
    {
      id: '112',
      name: 'Store operations and customer service',
      levelId: 'activity_k150',
    },
    {
      id: '115',
      name: 'Strategic client engagement and account management',
      levelId: 'activity_k150',
    },
    {
      id: '123',
      name: 'Strategic talent acquisition and workforce planning',
      levelId: 'activity_k150',
    },
  ];

// 59: rics_k10_9
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_59: ActivityDefaultSelection[] =
  [
    {
      id: '28',
      name: 'Customer service operations',
      levelId: 'activity_k150',
    },
    {
      id: '32',
      name: 'Data analysis and visualization',
      levelId: 'activity_k150',
    },
    {
      id: '79',
      name: 'Inventory control and logistics operations',
      levelId: 'activity_k150',
    },
    {
      id: '127',
      name: 'Strategic transformation and governance',
      levelId: 'activity_k150',
    },
    {
      id: '133',
      name: 'Talent acquisition and recruitment management',
      levelId: 'activity_k150',
    },
  ];

// 60: rics_k10_10
export const GENERATED_DEFAULT_CUSTOM_ACTIVITY_CUSTOM_60: ActivityDefaultSelection[] =
  [
    {
      id: '36',
      name: 'Data analysis and business insights',
      levelId: 'activity_k150',
    },
    {
      id: '64',
      name: 'Guest services and customer Experience',
      levelId: 'activity_k150',
    },
    {
      id: '73',
      name: 'Inventory control and order management',
      levelId: 'activity_k150',
    },
    {
      id: '125',
      name: 'Strategic initiative and program management',
      levelId: 'activity_k150',
    },
    {
      id: '132',
      name: 'Talent acquisition and recruitment',
      levelId: 'activity_k150',
    },
  ];
